import BacnetObjects from '../../../base/menu/airdome/BacnetObjects';

const bacnetObjects: BacnetObjects = {
  categoryName: 'Bacnet objekt',
  view: 'Durchsuchung',
  edit: 'Bearbeitung'
};

export default bacnetObjects;
